var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeadphones = function SvgHeadphones(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.55 12.188a6.501 6.501 0 0 1 12.9 0A2.5 2.5 0 0 0 17.5 12a1.5 1.5 0 0 0-1.5 1.5v4a1.5 1.5 0 0 0 1.5 1.5 2.5 2.5 0 0 0 2.5-2.5V13a8 8 0 0 0-8-8 8 8 0 0 0-8 8v3.5A2.5 2.5 0 0 0 6.5 19 1.5 1.5 0 0 0 8 17.5v-4A1.5 1.5 0 0 0 6.5 12c-.338 0-.656.066-.95.188M5.5 14.5c0-.553.447-1 1-1v4c-.553 0-1-.447-1-1v-2m13 0v2c0 .553-.447 1-1 1v-4c.553 0 1 .447 1 1"
  })));
};
export default SvgHeadphones;